import { render, staticRenderFns } from "./VendorEdit.vue?vue&type=template&id=74457b42&scoped=true&"
import script from "./VendorEdit.vue?vue&type=script&lang=js&"
export * from "./VendorEdit.vue?vue&type=script&lang=js&"
import style0 from "./VendorEdit.vue?vue&type=style&index=0&id=74457b42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74457b42",
  null
  
)

export default component.exports